<template>
  <div class="header">
    <el-row type="flex">
      <el-col :offset="1" :span="1">
        <img src="../assets/logo1.jpg" height="100" width="100"/>
      </el-col>
      <el-col :span="11" style="font-style:oblique;margin-top: 30px">
        <div style="font-size: 22px;">
          中国有色金属学会会议平台 <br>
          Conference platform of China Non-Ferrous Metal Society
        </div>
      </el-col>
      <el-col :offset="4" :span="6" v-if="isLogin===true">
        <a style="cursor: pointer;font-size: 18px;margin-right: 20px;" @click="toHome">首页 Home page</a>
        <a @click="toPerson" style="cursor: pointer;margin-right: 20px;font-size: 18px">个人中心 Personal center</a>
        <a style="cursor: pointer;font-size: 18px" @click="logout">退出 Log out</a>
      </el-col>
      <el-col v-else :offset="4" :span="6">
        <div style="display: flex;margin-top: 30px;float: right">
          <a style="cursor: pointer;font-size: 18px;margin-right:18px;" @click="toHome">首页 <br> Home page</a>
          <a @click="toLogin" style="cursor: pointer;margin-right:18px;font-size: 18px">登录 <br>Login</a>
          <a style="font-size: 18px;cursor: pointer" href="#/register">注册 <br> Sign Up</a>
        </div>

      </el-col>
      <!--      <el-col :offset="8" :span="4">-->
      <!--        <a style="cursor: pointer;font-size: 18px;margin-right: 20px;" @click="toHome">Home page</a>-->
      <!--        <a id="logout" style="display:none;cursor: pointer;font-size: 18px;margin-right: 20px;" @click="logout">Logout</a>-->
      <!--      </el-col>-->
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isLogin: '',
      time: '',
    }
  },
  mounted() {
    let id = this.$route.query.id
    if (id) {
      let logout = document.querySelector("#logout")
      logout.style.display = "inline-block";
    }
  },
  methods: {
    toHome() {
      this.$router.push('/home')
    },
    logout() {
      this.$confirm('This operation will exit the login. Do you want to continue?', 'prompt', {
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel',
        type: 'warning'
      }).then(() => {
        let id = this.$route.query.id
        window.localStorage.removeItem(`token${id}`)
        this.$router.push('/home')
        // window.localStorage.clear()
        // window.sessionStorage.clear()
        location.reload()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Logout has been cancelled'
        });
      });
    },
    toLogin() {
      let routeData = this.$router.resolve(
          {path: '/login'});
      window.open(routeData.href, '_self');
    },
    toPerson() {
      let routeData = this.$router.resolve(
          {path: '/person'});
      window.open(routeData.href, '_blank');
    },
  },
  computed: {},
  created() {

  },
  watch: {
    'localStorage': {
      handler() {
        if (window.localStorage.getItem('token')) {
          this.isLogin = true
        } else {
          this.isLogin = false
          window.localStorage.clear()
          window.sessionStorage.clear()
        }
      },
      deep: true,
      immediate: true,
    },
  }

}
</script>

<style scoped lang="less">
.header {
  background-color: white;
  color: #333;
  text-align: center;
  line-height: 30px;
  width: 100%;
  height: 100px;
}


.el-row {
  height: 110px;
}

.el-menu {
  height: 100px;
}

.el-menu-item {
  height: 100px;
}

.el-menu--horizontal > .el-menu-item {
  line-height: 100px;
  height: 100px;
  color: black;
  font-size: 18px;
}

a {
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: red;
}
</style>

